import { Row, Col, Form } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";

import classes from "./profile.module.scss";

const ProfileTabForm = ({ data, setData }) => {
	return (
		<Row className={classes.content_main_row}>
			<Col md={12} xs={12}>
				<Form autoComplete="off">
					<Form.Group as={Row} className="mb-3">
						<Form.Label column sm={2} xs={2} className={classes.label}>
							Nombre
						</Form.Label>
						<Col sm={10} xs={10}>
							<Form.Control
								value={data && data.name}
								onChange={(e) =>
									setData({
										...data,
										name: e.currentTarget.value,
									})
								}
								type="text"
							/>
						</Col>
					</Form.Group>

					<Form.Group as={Row} className="mb-3">
						<Form.Label column sm="2" xs={2} className={classes.label}>
							Email
						</Form.Label>
						<Col sm="10" xs={10}>
							<Form.Control
								value={data && data.email}
								onChange={(e) =>
									setData({
										...data,
										email: e.currentTarget.value,
									})
								}
								type="text"
							/>
						</Col>
					</Form.Group>

					<Form.Group as={Row} className="mb-3">
						<Form.Label column sm="2" xs={2} className={classes.label}>
							Teléfono
						</Form.Label>
						<Col sm="10" xs={10}>
							<PhoneInput
								initialValueFormat="national"
								defaultCountry="CL"
								value={data && data.phone ? `+${data.phone.replace(/\+/g, "")}` : ""}
								onChange={(value) => {
									setData({
										...data,
										phone: value,
									});
								}}
								type="text"
							/>
						</Col>
					</Form.Group>
				</Form>
			</Col>
		</Row>
	);
};

export default ProfileTabForm;
